import { GlobalRemoteEnum } from '@core/types';
import { getRootModule } from './redux';
import { getRawNavItems } from './routes/navItems';
import { translationsPL } from './i18nTranslator/translations';
import { createWithRaccoonWrapper } from './components/withRaccoonWrapper/withRaccoonWrapper';
import MsgsHeaderItem from './header/MsgsHeaderItem';
import { configFields } from './api';

const getRootModuleAssert: any = () => getRootModule();

export const RACCOON_ID = 'RACCOON';

export const RACCOON_MODULE = {
  reduxModules: [getRootModuleAssert()],
  navItems: getRawNavItems(false),
  translations: {
    pl: translationsPL
  },
  headerItems: [MsgsHeaderItem],
  hoc: createWithRaccoonWrapper(false)
};

export const getRaccoonModule = ({ pimOnly,dynamicNavItemsProviders }: { pimOnly?: boolean;dynamicNavItemsProviders?:any } = {}) => ({
  id: RACCOON_ID,
  apiConfigFields: configFields,
  reduxModules: [getRootModuleAssert()],
  navItems: getRawNavItems(pimOnly),
  translations: {
    pl: translationsPL
  },
  enumsEndpoint: 'enums',
  headerItems: [MsgsHeaderItem],
  hoc: createWithRaccoonWrapper(pimOnly),
  dynamicNavItemsProviders: dynamicNavItemsProviders
});

export const Enums = Object.freeze({
  CECHA_DEFINICJA_TYP: 'CechaDefinicjaTyp',
  CECHA_TYP: 'CechaTyp',
  ENCJA_TYP: 'EncjaTyp',
  KANAL_SPRZEDAZY_TYP: 'KanalSprzedazyTyp',
  KANAL_TYP: 'KanalTyp',
  MESSAGE_TYPE: 'MessageType',
  NUMERACJA_RESET_TYP: 'NumeracjaResetTyp',
  NUMERACJA_TYP: 'NumeracjaTyp',
  PARAMETR_TYP: 'ParametrTyp',
  PLATNOSC_TYP: 'PlatnoscTyp',
  PLIK_TYP: 'PlikTyp',
  POZYCJA_WARUNEK_TYP: 'PozycjaWarunekTyp',
  PROMOCJA_TYP: 'PromocjaTyp',
  PYTANIE_TYP: 'PytanieTyp',
  RAPORT_TYP: 'RaportTyp',
  REKLAMA_TYP: 'ReklamaTyp',
  RODZAJ_TOWARU_TYP: 'RodzajTowaruTyp',
  MODEL_REPREZENTANT_TYP: 'ModelReprezentantTyp',
  ROLA: 'Rola',
  SKLEP_TYP: 'SklepTyp',
  KONTRAHENT_TYP: 'KontahentTypType',
  STATUS_OPISANIA_TYP: 'StatusOpisaniaTyp',
  STATUS_PLATNOSCI_TYP: 'StatusPlatnosciTyp',
  STATUS_ZAMOWIENIA_TYP: 'StatusZamowieniaTyp',
  SECURE_SOCKET_OPTIONS: 'SecureSocketOptions',
  TOWAR_OPINIA_STATUS: 'TowarOpiniaStatus',
  TOWAR_STATUS_TYP: 'TowarStatusTyp',
  WARIANT_TYP: 'WariantTyp',
  WYSTAWIANIE_OPINII_MODEL_TYP: 'WystawianieOpiniModelTyp',
  ZAOKRAGLENIE_SPOSOB_TYP: 'ZaokraglenieSposobTyp',
  REKORD_DODANY_AKCJA_STATUS_TYP:'RekordDodanyAkcjaStatusTyp',
  CENY_MODEL_LICZENIA_TYP: 'CenyModelLiczeniaTyp',
  MODEL_PREZENTACJI_KATEGORII_TYP: 'ModelPrezentacjiKategoriiType',
  ...GlobalRemoteEnum
});

export { paths } from '@modules/raccoon/src/routes/app-paths';
